import {
  CLEAR_COLABORADORES_ACTION,
  FETCH_COLABORADORES,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_COLABORADORES,
  FETCHED_COLABORADORES,
  FETCHING_COLABORADORES,
  CLEAR_COLLABORATOR_INFO,
  SET_COLLABORATOR,
  FETCHING_COLLABORATOR,
  FETCHED_COLLABORATOR,
  SUBMITED_COLABORADOR,
  SUBMIT_COLABORADOR_ERROR,
  RESET_COLABORADOR_SUBMIT,
  SUBMIT_FILES_ERROR,
  SUBMITTED_FILES,
  SUBMIT_CAPTURES_ERROR,
  SUBMITTED_CAPTURES,
  SUBMITTED_SIGNATURES,
  SUBMIT_SIGNATURES_ERROR,
  SUBMITTED_FINGERPRINTERS,
  SUBMIT_FINGERPRINTERS_ERROR,
  CLEAR_FINGERPRINTERS,
  CLEAR_CAPTURES,
  CLEAR_ALERT_DIALOG,
  RESET_COLABORADOR_PROCESSING,
  STARTED_COLABORADOR_PROCESSING,
  GENERATE_CREDENTIAL,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_colaboradores: false,
  processing_colaborador: false,
  loading_collaborator: false,
};

const getters = {
  is_loading() {
    return state.loading_colaboradores;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  colaborador_processing() {
    return state.processing_colaborador;
  },
};

const actions = {
  [GENERATE_CREDENTIAL](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_COLLABORATOR);
      context.commit(CLEAR_COLLABORATOR_INFO);
      ApiService.post('usuarios/generate_user_credential', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_COLABORADORES](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_COLABORADORES);
      ApiService.post('censos', data)
        .then(({ data }) => {
          context.commit(FETCHED_COLABORADORES);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_COLABORADORES);
        });
    });
  },
  [CLEAR_COLABORADORES_ACTION](context) {
    context.commit(CLEAR_COLABORADORES);
  },
};

const mutations = {
  [FETCHING_COLABORADORES](state) {
    state.loading_colaboradores = true;
  },
  [FETCHED_COLABORADORES](state) {
    state.loading_colaboradores = false;
  },
  [CLEAR_COLLABORATOR_INFO](state) {
    state.collaborator_info = {};
  },
  [SET_COLLABORATOR](state, data) {
    state.collaborator_info = data.colaborador;
  },
  [FETCHING_COLLABORATOR](state) {
    state.loading_collaborator = true;
  },
  [FETCHED_COLLABORATOR](state) {
    state.loading_collaborator = false;
  },
  [SUBMITED_COLABORADOR](state, data) {
    state.submited_colaborador = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_COLABORADOR_ERROR](state, data) {
    state.processing_colaborador = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_COLABORADOR_SUBMIT](state) {
    state.submited_colaborador = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [SUBMIT_FILES_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [SUBMITTED_FILES](state, data) {
    state.submitted_files = data.data;
  },
  [SUBMIT_CAPTURES_ERROR](state, data) {
    state.alertDialog = true;
    state.alertDialogMessage = data;
    state.alertDialogType = 'error';
  },
  [SUBMITTED_CAPTURES](state, data) {
    state.alertDialog = true;
    state.alertDialogMessage = data.message;
    state.alertDialogType = 'success';
    state.submitted_captures = data.data;
  },
  [SUBMIT_SIGNATURES_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [SUBMITTED_SIGNATURES](state, data) {
    state.alertDialog = true;
    state.alertDialogMessage = data.message;
    state.alertDialogType = 'success';
    state.submitted_signatures = data.data;
  },
  [SUBMIT_FINGERPRINTERS_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [SUBMITTED_FINGERPRINTERS](state, data) {
    state.alertDialog = true;
    state.alertDialogMessage = data.message;
    state.alertDialogType = 'success';
    state.submitted_fingerprinters = data.data;
  },
  [CLEAR_FINGERPRINTERS](state) {
    state.submitted_fingerprinters = [];
  },
  [CLEAR_CAPTURES](state) {
    state.submitted_captures = [];
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_COLABORADOR_PROCESSING](state) {
    state.processing_colaborador = false;
  },
  [STARTED_COLABORADOR_PROCESSING](state) {
    state.processing_colaborador = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
